import { CloudDownload } from '@mui/icons-material';
import { Badge, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid } from '@mui/material';
import React from 'react'
import { TextForm } from '../../../components/TextBox';
import SelectForm from '../../../components/SelectBox/SelectForm';
import { useForm } from 'react-hook-form';
import { useEffect } from 'react';
import { useState } from 'react';
import SupBankttachmentDialog from '../DueDiligenceSup/components/SupBankAttachment';
import { useTranslation } from 'react-i18next';

export default function BankAddDialog({ open, handleClose, doubleClickBool, editData, setTableData, tableData, currencies, vendorId, country }) {
  const { handleSubmit,
    control,
    formState: { errors }, reset, setValue } = useForm({ mode: "onTouched" });

  const { t } = useTranslation('supplier')


  const [nextId, setNextId] = useState(0)

  const [attachmentAdd, setAttachmentAdd] = useState([])
  const [attachmentEdit, setAttachmentEdit] = useState([])
  async function onSubmit(data) {
    setNextId((x) => x - 1);

    const newDataItem = {
      ...data,
      id: nextId,
      vendorId: vendorId,
      type: 0
    };

    if (doubleClickBool) {
      const newData = tableData.map(item => {
        if (item.id === editData.id) {
          return { ...item, ...newDataItem, ...data, accountVerificationLetter: attachmentEdit };

        }
        return item;

      });

      setTableData([...newData]);

    } else {
      newDataItem.accountVerificationLetter = attachmentAdd
      setTableData([...tableData, newDataItem])
    }
    handleClose()
    setAttachmentAdd([])
    setAttachmentEdit([])
    reset([])
  }

  useEffect(() => {

    // Edit Double click
    if (doubleClickBool) {
      reset(editData)
    } // Add Button
    else if (open) {
      reset({
        accountNumber: '',
      })   // Close Modal
    } else {
      reset([])
    }


  }, [reset, open, doubleClickBool, editData])


  const [openAttachmentDialog, setOpenAttachmentDialog] = useState(false)

  const handleChangeData = (e) => {

    if (doubleClickBool) {
      const newData = tableData.map(item => {
        if (item.id === editData.id) {
          return {
            ...item,
            accountVerificationLetter: e
          };
        }
        return item;
      });
      setAttachmentEdit(e)
      setTableData(newData)
    } else {
      setAttachmentAdd(e)
    }

    // const index = newData.findIndex(item => item.id === editData.id)
  };

  const [currencyDisabled, setCurrencyDisabled] = useState(false)

  useEffect(() => {
    if (country === 'AZ' && open) {
      setValue('currency', 'AZN')
      setCurrencyDisabled(true)
    } else {
      setCurrencyDisabled(false)

    }
  }, [country, setValue, open])

  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box>
            {doubleClickBool ? 'Edit Bank' : 'Add Bank'}
          </Box>

        </DialogTitle>
        <Divider />

        <DialogContent>
          <form onSubmit={handleSubmit(onSubmit)} noValidate >
            <Box sx={{ width: '100%' }}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextForm label={t('beneficiary')} dynamicField='beneficiary'
                    control={control} errors={errors}
                    required={true}
                    disabled={false} />
                </Grid>

                <Grid item xs={6}>
                  <TextForm label={t('beneficiaryTaxId')} dynamicField='beneficiaruTaxId'
                    control={control} errors={errors}
                    required={true}
                    min={1} max={25} disabled={false} />
                </Grid>

                <Grid item xs={6}>
                  <TextForm label={t('bankAddress')} dynamicField='address'
                    control={control} errors={errors}
                    required={true}
                    disabled={false} />
                </Grid>

                <Grid item xs={6}>
                  <TextForm label={t('bankAccountNumber')} dynamicField='accountNumber'
                    control={control} errors={errors}
                    required={true}
                    disabled={false} />
                </Grid>

                <Grid item xs={6}>
                  <TextForm label='Bank' dynamicField='bank'
                    control={control} errors={errors}
                    required={true}
                    disabled={false} />
                </Grid>

                <Grid item xs={6}>
                  <TextForm label='SWIFT' dynamicField='swift'
                    control={control} errors={errors}
                    required={true}
                    disabled={false} />
                </Grid>

                <Grid item xs={6}>
                  <TextForm label={t('bankCode')} dynamicField='bankCode'
                    control={control} errors={errors}
                    required={true}
                    disabled={false} />
                </Grid>

                <Grid item xs={6}>
                  <SelectForm label={t('currency')} id='currencyCode' name='currencyCode'
                    control={control} errors={errors} required={true}
                    dynamicField='currency' data={currencies} disabled={false} />
                  {/* disabled={currencyDisabled} */}
                </Grid>

                <Grid item xs={6}>
                  <TextForm label={t('bankTaxId')} dynamicField='bankTaxId'
                    control={control} errors={errors}
                    required={true}
                    min={1} max={25} disabled={false} />
                </Grid>

                <Grid item xs={6}>
                  <TextForm label={t('correspondentAccount')} dynamicField='correspondentAccount'
                    control={control} errors={errors}
                    required={true}
                    min={1} max={30} disabled={false} />
                </Grid>

              </Grid>
            </Box>
          </form>
        </DialogContent>

        <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box>

            <Badge badgeContent={editData?.accountVerificationLetter?.filter((x) => x.type === 0)?.length} color="error">
              <Button size='small' onClick={() => setOpenAttachmentDialog(true)} variant='contained' endIcon={
                <CloudDownload />
              }>{t('attachments')}</Button>
            </Badge>
            <SupBankttachmentDialog
              open={openAttachmentDialog}
              setOpen={setOpenAttachmentDialog}
              module={'Vendors'}
              value={editData?.accountVerificationLetter}
              setValue={(e) => handleChangeData(e)}
              initialData={editData?.accountVerificationLetter}
            />
          </Box>
          <Box>
            <Button onClick={handleSubmit(onSubmit)} variant='contained'>{t('save')}</Button>
            <Button onClick={handleClose}>{t('cancel')}</Button>
          </Box>
        </DialogActions>

      </Dialog>

    </div>
  )
}
